import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Decode a Relay-style base64 ID to extract the UUID
 * Handles IDs like "T3JkZXJOb2RlOjEyMzQ1Njc4LTEyMzQtMTIzNC0xMjM0LTEyMzQ1Njc4OTAxMg=="
 * which decode to "OrderNode:12345678-1234-1234-1234-123456789012"
 */
export function decodeOrderId(base64Id: string): string {
  try {
    const decoded = atob(base64Id)
    // Extract UUID after the colon (removes "OrderNode:" prefix)
    const uuidMatch = decoded.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i)
    return uuidMatch ? uuidMatch[0] : decoded
  } catch {
    // If decoding fails, return the original ID (might already be a UUID)
    return base64Id
  }
}
